import { render, staticRenderFns } from "./WorkspaceManageModal.vue?vue&type=template&id=19f13892&scoped=true"
import script from "./WorkspaceManageModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceManageModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceManageModal.vue?vue&type=style&index=0&id=19f13892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f13892",
  null
  
)

export default component.exports